import { useRef, useState } from "react";
import { Canvas } from "@react-three/fiber";
import { Box } from "./Box";
import OrbitControlsComponent from "./OrbitControlsComponent";
import Brain from "./Brain";
import { useMetadata } from "../hooks";
import { Config } from "../types";
import BrainUI from "./BrainUI";
import MultipleResourceCube from "./MultipleResourceCube";
import { Text } from "@react-three/drei";
import CommonUI from "./CommonUI";
import ResourceInfo from "./ResourceInfo";
import UI from "./UI";

export const defaultSettings: Config = {
  showRightHemisphere: true,
  showLeftHemisphere: true,
  colormap: "resource", // Also filter by
  filtexIdx: [],
  intersectionHoverIdsCube: [],
  intersectionHoverIdsRegion: [],
  selectedResource: undefined,
  selectedRegion: undefined,
  disabledPointOpacity: 30,
  disabledCubeOpacity: 200,
  brainPointSize: 500,
};

function App() {
  const [config, setConfig] = useState(defaultSettings);

  const ref = useRef(null);

  const metadataDict = useMetadata();

  return (
    <div className="app-layout">
      {metadataDict && (
        <>
          <div className={"canvases-layout"}>
            <Canvas className="canvas-layout brain" ref={ref}>
              <OrbitControlsComponent initialPosition={[-250, 0, 0]} />
              <ambientLight />
              <pointLight position={[100, 0, 0]} />
              <pointLight position={[100, -100, 0]} />
              <pointLight position={[0, -100, 100]} />
              <pointLight position={[0, 100, 0]} />
              <Brain metadataDict={metadataDict} config={config} setConfig={setConfig} />
            </Canvas>
            <Canvas className="canvas-layout cube" ref={ref}>
              <OrbitControlsComponent initialPosition={[-70, 60, 180]} />
              <ambientLight />
              <MultipleResourceCube config={config} setConfig={setConfig} />
            </Canvas>
          </div>
          <div className="footer-layout">
            <UI config={config} setConfig={setConfig} metadataDict={metadataDict} />
            {config.selectedResource && (
              <ResourceInfo config={config} setConfig={setConfig} metadataDict={metadataDict} />
            )}
          </div>

          <div className="controls">
            <p>Controls:</p>
            <p>• Use mouse to orbit camera</p>
            <p>• Zoom in/out using mouse wheel</p>
            <p>• Double click resource to see detailed info</p>
          </div>
        </>
      )}
    </div>
  );
}

export default App;
